import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import BannersShowcase from './BannersShowcase';
import { FILTERKEYS } from './constants';

const BannersList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-banner-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((banner, i) => (
                  <li key={`banner-${group.type}-showcase-${i}`}>
                    <BannersShowcase {...banner} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

BannersList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

BannersList.displayName = 'BannersList';

export default BannersList;



// WEBPACK FOOTER //
// ./src/containers/components/Banner/BannersList.js